<template>
  <v-menu
    ref="menuDateFilter"
    v-model="menuDateFilter"
    :close-on-content-click="false"
    transition="scale-transition"
    min-width="290px"
    offset-y
  >
    <!-- Affichage de la date -->
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDate"
        :label="label"
        color="bluecolor"
        prepend-icon="mdi-calendar-outline"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>

    <!-- Sélectionneur de date -->
    <v-date-picker
      v-model="date"
      color="bluecolor"
      landscape
      scrollable
      :locale="lang"
      @input="setDate"
    />
  </v-menu>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import moment from 'moment'
  import 'moment/locale/fr'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'DateFilter',

    /* Paramètres */
    props: {
      label: {
        type: String,
        default: '',
      },
      defaultDate: {
        type: String,
        default: undefined,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        date: this.defaultDate,
        menuDateFilter: false,
        lang: 'fr-FR',
        cancelText: 'Annuler',
      }
    },

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      formattedDate () {
        return this.formatDate(this.date)
      },
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      defaultDate: function (newVal) {
        this.date = moment(newVal).format('YYYY-MM-DD')
      },
    },

    /* Fonctions internes */
    methods: {
      formatDate: function (date) {
        return date ? moment(date).format('L') : ''
      },

      setDate: function (date) {
        this.menuDateFilter = false
        // 'YYYY-MM-DD' est le format retourné par l'API
        this.$emit('set-date', date ? moment(date).format('YYYY-MM-DD') : '')
      },
    },

  }
</script>
